"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtraInformation = void 0;
var react_1 = __importDefault(require("react"));
var ExtraInformation_module_scss_1 = __importDefault(require("./ExtraInformation.module.scss"));
var ExtraInformation = function (props) {
    var title = props.title, information = props.information;
    return (react_1.default.createElement("section", { className: ExtraInformation_module_scss_1.default.extra_information },
        react_1.default.createElement("h2", { className: ExtraInformation_module_scss_1.default.extra_information__title }, title),
        react_1.default.createElement("ul", { className: ExtraInformation_module_scss_1.default.extra_information__list }, information.map(function (info) {
            return (react_1.default.createElement("li", { key: info.title, className: ExtraInformation_module_scss_1.default.extra_information__item },
                react_1.default.createElement("h5", null, info.title),
                react_1.default.createElement("span", { className: ExtraInformation_module_scss_1.default.extra_information__dashed }),
                react_1.default.createElement("span", null, info.description)));
        }))));
};
exports.ExtraInformation = ExtraInformation;
